export enum Sender {
    USER = 'user',
    BOT = 'bot',
    SYSTEM = 'system',
}

export interface Message {
    id: string;
    text: string;
    sender: Sender;
    timestamp: Date;
    internalAnalysis?: string; // For "reasoning" content if available
}
